export enum RegisterViewState {
  REGISTER = "register",
  REGISTER_DISCLAIMER = "registerDisclaimer",
}
